/**
 * Phase 6.BRONZE-INGEST — position import types.
 * Mirrors PositionImportController and ImportResultResponse on the backend.
 */

export type ProductType = 'bonds' | 'loans' | 'deposits' | 'interbank' | 'offbalance';

export interface ProductTypeMeta {
  label:         string;
  description:   string;
  instruments:   string;
  templateFile:  string;
}

export interface ProductTypeMeta {
  label:         string;
  description:   string;
  instruments:   string;
  templateFile:  string;
  templateCsv:   string;   // full CSV content for client-side Blob download
}

export const PRODUCT_TYPES: Record<ProductType, ProductTypeMeta> = {
  bonds: {
    label:        'Bonds & T-Bills',
    description:  'Fixed-income investment securities: government bonds, corporate bonds, T-bills, CDs.',
    instruments:  'BOND, T_BILL, CD',
    templateFile: 'cubix_template_bonds.csv',
    templateCsv: [
      'deal_id,currency,principal_amount,maturity_date,rate_type,interest_rate,coupon_frequency',
      'BOND-001,MAD,10000000,2028-01-15,FIXED,0.045000,ANNUAL',
      'BOND-002,MAD,5000000,2027-06-30,FIXED,0.038000,SEMI_ANNUAL',
      'BOND-003,EUR,8000000,2029-03-31,FIXED,0.042000,ANNUAL',
    ].join('\n'),
  },
  loans: {
    label:        'Loans',
    description:  'Loan book: corporate loans, SME loans, retail loans (fixed or floating rate).',
    instruments:  'LOAN',
    templateFile: 'cubix_template_loans.csv',
    templateCsv: [
      'deal_id,currency,principal_amount,maturity_date,rate_type,interest_rate',
      'LOAN-001,MAD,15000000,2027-03-31,FIXED,0.055000',
      'LOAN-002,MAD,8000000,2028-12-15,FLOAT,0.030000',
      'LOAN-003,EUR,5000000,2026-09-30,FIXED,0.048000',
    ].join('\n'),
  },
  deposits: {
    label:        'Deposits',
    description:  'Customer deposit products: demand accounts (DAV), savings accounts, term deposits.',
    instruments:  'DAV, SAVINGS, TERM',
    templateFile: 'cubix_template_deposits.csv',
    templateCsv: [
      'deal_id,instrument_type,currency,principal_amount,maturity_date,interest_rate',
      'DAV-001,DAV,MAD,50000000,,0.010000',
      'DAV-002,DAV,EUR,20000000,,0.008000',
      'SAVINGS-001,SAVINGS,MAD,30000000,,0.015000',
      'TERM-001,TERM,MAD,12000000,2026-09-30,0.032000',
      'TERM-002,TERM,MAD,8000000,2027-03-31,0.035000',
    ].join('\n'),
  },
  interbank: {
    label:        'Interbank & Overdrafts',
    description:  'Interbank placements/borrowings and current-account overdrafts.',
    instruments:  'INTERBANK, OVERDRAFT',
    templateFile: 'cubix_template_interbank.csv',
    templateCsv: [
      'deal_id,instrument_type,currency,principal_amount,maturity_date,rate_type,interest_rate',
      'IB-PLACE-001,INTERBANK,MAD,20000000,2026-07-31,FLOAT,0.030000',
      'IB-BORROW-001,INTERBANK,MAD,15000000,2026-06-30,FLOAT,0.028000',
      'OD-CORP-001,OVERDRAFT,MAD,5000000,,FLOAT,0.085000',
      'OD-RETAIL-001,OVERDRAFT,MAD,3000000,,FLOAT,0.090000',
    ].join('\n'),
  },
  offbalance: {
    label:        'Off-Balance Sheet',
    description:  'Irrevocable commitments and credit facilities not on the balance sheet.',
    instruments:  'COMMITMENT',
    templateFile: 'cubix_template_offbalance.csv',
    templateCsv: [
      'deal_id,instrument_type,currency,principal_amount,maturity_date',
      'COMMIT-CORP-001,COMMITMENT,MAD,10000000,2027-06-30',
      'COMMIT-SME-001,COMMITMENT,MAD,4000000,2026-12-31',
      'COMMIT-RETAIL-001,COMMITMENT,EUR,2500000,2027-03-31',
    ].join('\n'),
  },
};

/** Mirrors ImportResultResponse on the backend. */
export interface ImportResult {
  productType:    string;
  asOfDate:       string;
  rowsImported:   number;
  gapCfRowsBuilt: number;
  lcrRowsBuilt:   number;
  gapResultId:    string | null;
  nimResultId:    string | null;
  lcrResultId:    string | null;
  eveResultId:    string | null;
  gapError:       string | null;
  nimError:       string | null;
  lcrError:       string | null;
  eveError:       string | null;
}
